<template>
    <div class="top_con">
       <el-form :inline="true" class="demo-form-inline">
           <el-row :gutter="10">
                <el-form-item label="累计付款总金额">
                    <el-input v-model="money"  :disabled="true" placeholder="自动获取"></el-input>
                </el-form-item>
                 <el-form-item label="累计付款总人数">
                    <el-input v-model="num"  :disabled="true" placeholder="自动获取"></el-input>
                </el-form-item>
           </el-row>
        </el-form>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" max-height="580px">
            <el-table-column prop="id" label="序号"> </el-table-column>
            <el-table-column  prop="nickname"  label="用户昵称"></el-table-column>
            <el-table-column prop="paytime"  label="付款时间" ></el-table-column>
            <el-table-column prop="jine"  label="付款金额(元)" ></el-table-column>
            <el-table-column prop="expiretime"  label="有效期至" ></el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
    </div>
</template>
<script>
import {geTjList} from '@/utils/api'
export default {
    data(){
        return{
            user:{},
            formInline: {
                type:'',
                project: '',
                money: ''
            },
            formLabelWidth: '120px',
            value:10,
            total:10,
            multipleSelection:[],
            tableData: [],
            money:'',
            num:''
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
             let param ={
                numPerPage:this.value,
                pageNum:this.pageNum
            }
            geTjList(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list;
            });
        },
        
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        geTjList().then(res=>{
            this.total=res.list.total;
            this.tableData=res.list.list;
            this.money=res.total_jine
            this.num=res.total_num
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
</style>



// WEBPACK FOOTER //
// src/components/CashFlows.vue